import React from 'react'


import {LogoHutRewardsImageProps} from '../../../types/interfaces/LogoHutRewardInterface'
import { LogoHutRewardsContainer, LogoHutRewardsImage } from './logoHutRewardsStyled'

export interface PointsHeaderProps extends LogoHutRewardsImageProps {}

export const LogoHutRewards: React.FC<PointsHeaderProps> = ({
    size = 'large',
    showBgImage,
}) => {
    return (
        <LogoHutRewardsContainer>
            <LogoHutRewardsImage size={size} showBgImage={showBgImage}>Hut Rewards</LogoHutRewardsImage>
        </LogoHutRewardsContainer>
    )
}